import React from "react";
import { NavLink } from "react-router-dom";

const Link = ({ linktype, url, buttonText, className, children, callback }) => {
  if (linktype === "external") {
    return (
      <a href={url} className={className}>
        {buttonText || children}
      </a>
    );
  }

  return (
    <NavLink to={url} className={className} activeClassName="active" onClick={callback}>
      {buttonText || children}
    </NavLink>
  );
};

export default Link;
